import type { SelectOption } from '@dostavkee/web-ui'
import type { QueryObserverOptions } from '@tanstack/react-query'

import {
    type GetUsersRecruiters400,
    type GetUsersRecruitersQueryKey,
    type GetUsersRecruitersQueryResponse,
    type ResponseErrorConfig,
    useGetUsersRecruiters,
} from '@/shared/api'

interface UseRecruiterOptionsArguments {
    query?: Partial<
        QueryObserverOptions<
            GetUsersRecruitersQueryResponse,
            ResponseErrorConfig<GetUsersRecruiters400>,
            GetUsersRecruitersQueryResponse,
            GetUsersRecruitersQueryResponse,
            GetUsersRecruitersQueryKey
        >
    >
}

export const useRecruiterOptionsFetch = ({ query }: UseRecruiterOptionsArguments = {}) => {
    const { data, isLoading, error } = useGetUsersRecruiters({
        query,
    })

    const recruiterOptions: SelectOption[] | undefined = data?.recruiters?.map((recruiter) => ({
        id: recruiter.id,
        name: recruiter.name,
    }))

    return {
        recruiterOptions,
        isLoading,
        error,
    }
}
